<div class="header-main">
    <core-title-section-labels
        [text]="'Project <small>(#' + project.id+ ')</small>'"
        [labels]="project.labels"
    ></core-title-section-labels>
</div>
